import AbstractCanopyStyle from "./AbstractCanopyStyle";
import { DEFAULT_OPACITY } from "../../../shared/constants";

export default class ConiferCanopyStyle extends AbstractCanopyStyle {
    // Needles extend max 0.1r beyond circumference
    get absMaxSizeMultiplier() {
        return 1.1;
    }

    generatePoints() {
        let r = this.ellipse.absSize / 2;
        let needles = [];
        let numNeedles = Math.pow(this.ellipse.absSize, 0.6) * 1.2;

        for (let i = 0; i < numNeedles; i++) {
            let baseAngle = (i / numNeedles) * this.p.TWO_PI;
            // High angular variability — up to ±0.4 rad (~23°)
            let angleNoise = this.p.noise(i * 3.7 / numNeedles + 10);
            let angle = baseAngle + (angleNoise - 0.5) * 4.5;
            // Outer tip: just barely outside circumference, 0.01r–0.1r protrusion
            // Coordinates normalized by absSize so they scale with currentSize at render time
            let outerNoise = this.p.noise(i * 5.0 / numNeedles);
            let outerR = (r + Math.pow(r, 0.8) * (0.01 + outerNoise * 0.09)) / this.ellipse.absSize;
            // Inner start: highly variable, 0.15r–0.9r from center
            let innerR = r * (0.15 + this.p.random() * 0.75) / this.ellipse.absSize;
            needles.push({
                innerDx: innerR * this.p.cos(angle),
                innerDy: innerR * this.p.sin(angle),
                outerDx: outerR * this.p.cos(angle),
                outerDy: outerR * this.p.sin(angle),
            });
        }
        return needles;
    }

    display(g, opacity) {
        this.ensurePoints();
        let ellipse = this.ellipse;
        let scale = ellipse.currentSize; // needle coords are normalized, scale by currentSize

        // Fill circle behind needles
        if (ellipse.appearance.fillColor) {
            ellipse.appearance.fillColor.setAlpha(opacity * DEFAULT_OPACITY);
            g.fill(ellipse.appearance.fillColor);
            g.noStroke();
            g.ellipse(ellipse.currentX, ellipse.currentY, ellipse.currentSize);
        }

        g.strokeCap(g.ROUND);
        g.strokeWeight((ellipse.appearance.strokeWidth ?? 1) * this.view.scale);
        if (ellipse.appearance.strokeColor) {
            ellipse.appearance.strokeColor.setAlpha(opacity * 255);
            g.stroke(ellipse.appearance.strokeColor);
        } else {
            g.stroke(g.color(0, 0, 0, opacity * 255));
        }

        for (let needle of this._points) {
            g.line(
                (ellipse.absX / ellipse.absSize + needle.innerDx) * scale,
                (ellipse.absY / ellipse.absSize + needle.innerDy) * scale,
                (ellipse.absX / ellipse.absSize + needle.outerDx) * scale,
                (ellipse.absY / ellipse.absSize + needle.outerDy) * scale,
            );
        }
    }

    getMiniView(size) {
        this.ensurePoints();
        // Needle coords are normalized by absSize, so extent is the normalized bounding radius
        let extent = this.absMaxSizeMultiplier / 2;
        return {
            type: 'conifer',
            lines: this._points.map(needle => ({
                x1: this.p.map(needle.innerDx, -extent, extent, 20 - size / 2, 20 + size / 2),
                y1: this.p.map(needle.innerDy, -extent, extent, 20 - size / 2, 20 + size / 2),
                x2: this.p.map(needle.outerDx, -extent, extent, 20 - size / 2, 20 + size / 2),
                y2: this.p.map(needle.outerDy, -extent, extent, 20 - size / 2, 20 + size / 2),
            })),
        };
    }
}
